var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/edit-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/edit-light",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5034256,7.9930339 L18.8827057,9.61375376 C18.7174648,9.77899461 18.4502917,9.77899461 18.2850509,9.61375376 L14.3827164,5.71141932 C14.2174756,5.54617847 14.2174756,5.27900534 14.3827164,5.11376449 L16.0034363,3.49304463 C16.6608291,2.83565179 17.7295903,2.83565179 18.3905194,3.49304463 L20.5034256,5.60595082 C21.1643546,6.26337799 21.1643546,7.33210484 20.5034256,7.9930339 Z M12.990546,6.50593494 C13.1557868,6.34069409 13.42296,6.34069409 13.5917027,6.50593494 L17.4940371,10.4082694 C17.659278,10.5735102 17.659278,10.8406834 17.4940371,11.0059242 L8.26204162,20.237954 L3.99056743,20.9867735 C3.41399257,21.0852039 2.91126626,20.5859795 3.01323288,20.009439 L3.75851614,15.7379648 L12.990546,6.50593494 Z M6.0928993,17.9035709 L6.0928993,16.2160749 L4.81673734,16.2160749 L4.41947953,18.4836476 L5.51282256,19.5769907 L7.78039528,19.1797328 L7.78039528,17.9035709 L6.0928993,17.9035709 Z",
    id: "pencil",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLight);
export default __webpack_public_path__ + "static/media/edit-light.cd8fee33.svg";
export { ForwardRef as ReactComponent };